import { useReducer } from 'react';
import type { ReactElement } from 'react';
import { Transition } from 'react-transition-group';
import type { TransitionStatus } from 'react-transition-group';

type Props = {
  duration: number;
  onExited(): void;
  children(p: { state: TransitionStatus; exit(): void }): ReactElement;
};

export const MountTransition = ({ onExited, duration, children }: Props) => {
  const [transitionIn, startTransitionOut] = useReducer(() => false, true);

  return (
    <Transition
      in={transitionIn}
      mountOnEnter
      unmountOnExit
      timeout={duration}
      onExited={onExited}
    >
      {(state) => children({ state, exit: startTransitionOut })}
    </Transition>
  );
};
